"use strict";
// TODO: can't figure out how to configure typeroots and export this as global types.
// this really should be in a .d.ts file but ts-node/tests are barfing if we do that.
Object.defineProperty(exports, "__esModule", { value: true });
